<template>
  <div class="panel-section">
    <h3 class="section-title">{{ $t('overview.customerService.title') }}</h3>
    <div class="service-card">
      <div class="service-hotline">
        <div class="hotline-title">{{ $t('overview.customerService.hotLineTitle') }}</div>
        <div class="hotline-number"><i class="el-icon-phone"></i>&nbsp;{{ $t('overview.customerService.hotLinePhone') }}</div>
        <div class="hotline-desc">{{ $t('overview.customerService.hotLineDesc') }}</div>
      </div>
      <div class="manager-contact" v-loading="loading">
        <div class="contact-row" v-for="(item, index) in contactList" :key="index">
          <span class="label">{{ $t('overview.customerService.afterSalesManager', [index + 1]) }}：</span>
          <span class="value">{{ item.mobile }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CustomerService',
  data() {
    return {
      contactList: [],
      loading: false,
    }
  },
  mounted() {
    this.getConsumerInfo();
  },

  methods: {
    getConsumerInfo() {
      this.loading = true;
      this.$api.getConsumerInfoByName().then(res => {
        if (res.errno === 10000 && res.data && res.data.consumer) {
          this.contactList = res.data.consumer.afterSaleContacts;
        }
      }).finally(() => {
        this.loading = false
      })
    }
  },
}
</script>

<style lang="scss" scoped>
.panel-section {
  background: #fff;
  padding: 24px;
  border-radius: 8px;
  margin-bottom: 15px;
  .section-title {
      font-size: 14px;
      font-weight: 600;
      color: rgba(0, 0, 0, 0.85);
      margin: 0 0 16px 0;
  }

  // Service Card
  .service-card {
    .service-hotline {
      background: linear-gradient(180deg, rgba(44, 104, 255, 0.08) 0%, rgba(255, 255, 255, 0.08) 100%), #FFF;
      padding: 16px;
      text-align: center;
      border-radius: 8px;
      margin-bottom: 16px;
      box-shadow: 0 1px 4px 1px rgba(0,0,0,0.04),0 3px 6px 0 rgba(0,0,0,0.03),0 1px 4px -3px rgba(0,0,0,0.02);
      .hotline-title {
        font-size: 13px;
        color: rgba(0, 0, 0, 0.85);
        margin-bottom: 8px;
        font-weight: bold;
      }

      .hotline-number {
        font-size: 24px;
        // color: #1D41FF;
        color: #F52F3E;
        font-weight: bold;
        margin: 12px 0;
      }

      .hotline-desc {
        font-size: 12px;
        color: rgba(0, 0, 0, 0.45);
      }
    }

    .manager-contact {
      font-size: 12px;
      color: rgba(0, 0, 0, 0.65);

      .contact-row {
        margin-bottom: 8px;
        display: flex;
        // justify-content: space-between;
        background: rgba(0, 0, 0, 0.02);
        // box-shadow: 0 1px 4px 1px rgba(0, 0, 0, 0.04), 0 3px 6px 0 rgba(0, 0, 0, 0.03), 0 1px 4px -3px rgba(0, 0, 0, 0.02);
        padding: 8px;
        border-radius: 8px;

        .label {
            color: rgba(0, 0, 0, 0.85);
            font-weight: 600;
        }

        .value {
            color: rgba(0, 0, 0, 0.65);
        }

        &:last-child {
          margin-bottom: 0;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/resourceOverview/components/sidePanelComponents/CustomerService.vue